<div class="modal" [ngStyle]="{'display': visible}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-backdrop fade in" style="height: 2607px;"></div>
  <div class="modal-dialog">
    <div class="modal-content" style="width: 550px;margin-left: 5%;    border-radius: 7px;">
      <div class="modal-header" style="line-height: 0.5;border-bottom: 1px solid #E74C3C;background: #E74C3C;border-top-right-radius: 7px;border-top-left-radius: 7px;">
        <div class="modal-title" style="color: white;font-size: 20px;font-variant-caps: all-small-caps;font-weight: 500">
          <i class="fas fa-exclamation-triangle" style="font-size: 33px;"></i>
          <span style="margin-left: 10px;">{{title}}</span>
        </div>
      </div>
      <div class="modal-body" [innerHTML]="body_content"></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger btn-lg btn-block" data-dismiss="modal" (click)="popupOkAction()">{{button_text}}</button>
      </div>
    </div>
  </div>
</div>
